module.exports = __webpack_public_path__ + "img/d2.d4681f25.png";